import { createAction } from '@reduxjs/toolkit'

import { INIT_MASTER_DEALER_DATA_ACTION } from '../configs'

/** Initialize partner dashboard - ./listeners/initMasterDealerDataListener */
export const initMDDataAction = createAction(
  INIT_MASTER_DEALER_DATA_ACTION,
  (partnerId: string, callback?: () => void) => {
    return {
      payload: { partnerId, callback },
    }
  }
)
